/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Swarmind Auth API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import { ApiActivateRegisterInput } from '../models';
// @ts-ignore
import { ApiChangePasswordInput } from '../models';
// @ts-ignore
import { ApiLoginInput } from '../models';
// @ts-ignore
import { ApiMeOutput } from '../models';
// @ts-ignore
import { ApiOTPVerifyInput } from '../models';
// @ts-ignore
import { ApiOTPVerifyOutput } from '../models';
// @ts-ignore
import { ApiPasswordResetConfirmInput } from '../models';
// @ts-ignore
import { ApiPasswordResetRequestInput } from '../models';
// @ts-ignore
import { ApiRegisterInput } from '../models';
// @ts-ignore
import { RestErrResponse } from '../models';
/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Activates account from email token and sets password.
         * @summary Activate account
         * @param {ApiActivateRegisterInput} [apiActivateRegisterInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNewAPIServiceFunc23: async (apiActivateRegisterInput?: ApiActivateRegisterInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/register/activate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiActivateRegisterInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Requests reset OTP by username/email with IP rate limit.
         * @summary Request password reset
         * @param {string} [xClientIP] Client IP set by API middleware
         * @param {string} [xForwardedFor] 
         * @param {string} [xRealIP] 
         * @param {ApiPasswordResetRequestInput} [apiPasswordResetRequestInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNewAPIServiceFunc24: async (xClientIP?: string, xForwardedFor?: string, xRealIP?: string, apiPasswordResetRequestInput?: ApiPasswordResetRequestInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/password/reset/request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xClientIP != null) {
                localVarHeaderParameter['X-Client-IP'] = String(xClientIP);
            }

            if (xForwardedFor != null) {
                localVarHeaderParameter['X-Forwarded-For'] = String(xForwardedFor);
            }

            if (xRealIP != null) {
                localVarHeaderParameter['X-Real-IP'] = String(xRealIP);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiPasswordResetRequestInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sets new password using reset action token.
         * @summary Confirm password reset
         * @param {ApiPasswordResetConfirmInput} [apiPasswordResetConfirmInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNewAPIServiceFunc25: async (apiPasswordResetConfirmInput?: ApiPasswordResetConfirmInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/password/reset/confirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiPasswordResetConfirmInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Changes password
         * @summary Change password
         * @param {number} xUserID Authenticated User ID — set by auth middleware, do not send manually
         * @param {string} [xAuthError] Auth error message — set by auth middleware, do not send manually
         * @param {boolean} [xHuggingfaceAuth] Huggingface auth flag — set by auth middleware, do not send manually
         * @param {ApiChangePasswordInput} [apiChangePasswordInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword: async (xUserID: number, xAuthError?: string, xHuggingfaceAuth?: boolean, apiChangePasswordInput?: ApiChangePasswordInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xUserID' is not null or undefined
            assertParamExists('changePassword', 'xUserID', xUserID)
            const localVarPath = `/change_password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xUserID != null) {
                localVarHeaderParameter['X-User-ID'] = typeof xUserID === 'string'
                    ? xUserID
                    : JSON.stringify(xUserID);
            }

            if (xAuthError != null) {
                localVarHeaderParameter['X-Auth-Error'] = String(xAuthError);
            }

            if (xHuggingfaceAuth != null) {
                localVarHeaderParameter['X-Huggingface-Auth'] = typeof xHuggingfaceAuth === 'string'
                    ? xHuggingfaceAuth
                    : JSON.stringify(xHuggingfaceAuth);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiChangePasswordInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns basic data about authenticated user
         * @summary Get me
         * @param {number} xUserID Authenticated User ID — set by auth middleware, do not send manually
         * @param {string} [xAuthError] Auth error message — set by auth middleware, do not send manually
         * @param {boolean} [xHuggingfaceAuth] Huggingface auth flag — set by auth middleware, do not send manually
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMe: async (xUserID: number, xAuthError?: string, xHuggingfaceAuth?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xUserID' is not null or undefined
            assertParamExists('getMe', 'xUserID', xUserID)
            const localVarPath = `/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xUserID != null) {
                localVarHeaderParameter['X-User-ID'] = typeof xUserID === 'string'
                    ? xUserID
                    : JSON.stringify(xUserID);
            }

            if (xAuthError != null) {
                localVarHeaderParameter['X-Auth-Error'] = String(xAuthError);
            }

            if (xHuggingfaceAuth != null) {
                localVarHeaderParameter['X-Huggingface-Auth'] = typeof xHuggingfaceAuth === 'string'
                    ? xHuggingfaceAuth
                    : JSON.stringify(xHuggingfaceAuth);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sets cookie if auth data is valid. Checks if already logged in and cookie is present.
         * @summary Login
         * @param {string} [jwt] we throw an \&#39;already logged in\&#39; error if cookie is valid and userId is present
         * @param {ApiLoginInput} [apiLoginInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (jwt?: string, apiLoginInput?: ApiLoginInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiLoginInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Invalidates auth cookie
         * @summary Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Regenerates Bearer API token, use /me to retreive it back afterwards
         * @summary Regenerate Bearer API Token
         * @param {number} xUserID Authenticated User ID — set by auth middleware, do not send manually
         * @param {string} [xAuthError] Auth error message — set by auth middleware, do not send manually
         * @param {boolean} [xHuggingfaceAuth] Huggingface auth flag — set by auth middleware, do not send manually
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regenerateToken: async (xUserID: number, xAuthError?: string, xHuggingfaceAuth?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xUserID' is not null or undefined
            assertParamExists('regenerateToken', 'xUserID', xUserID)
            const localVarPath = `/regenerate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xUserID != null) {
                localVarHeaderParameter['X-User-ID'] = typeof xUserID === 'string'
                    ? xUserID
                    : JSON.stringify(xUserID);
            }

            if (xAuthError != null) {
                localVarHeaderParameter['X-Auth-Error'] = String(xAuthError);
            }

            if (xHuggingfaceAuth != null) {
                localVarHeaderParameter['X-Huggingface-Auth'] = typeof xHuggingfaceAuth === 'string'
                    ? xHuggingfaceAuth
                    : JSON.stringify(xHuggingfaceAuth);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new user if auth data is valid. Checks if already logged in and cookie is present.
         * @summary Register
         * @param {string} [jwt] we throw an \&#39;already logged in\&#39; error if cookie is valid and userId is present
         * @param {ApiRegisterInput} [apiRegisterInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register: async (jwt?: string, apiRegisterInput?: ApiRegisterInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiRegisterInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Requests an OTP
         * @summary Request OTP
         * @param {string} [username] 
         * @param {string} [email] 
         * @param {number} [xUserID] Authenticated User ID — set by auth middleware, do not send manually
         * @param {string} [xAuthError] Auth error message — set by auth middleware, do not send manually
         * @param {boolean} [xHuggingfaceAuth] Huggingface auth flag — set by auth middleware, do not send manually
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestOTP: async (username?: string, email?: string, xUserID?: number, xAuthError?: string, xHuggingfaceAuth?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/otp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (xUserID != null) {
                localVarHeaderParameter['X-User-ID'] = typeof xUserID === 'string'
                    ? xUserID
                    : JSON.stringify(xUserID);
            }

            if (xAuthError != null) {
                localVarHeaderParameter['X-Auth-Error'] = String(xAuthError);
            }

            if (xHuggingfaceAuth != null) {
                localVarHeaderParameter['X-Huggingface-Auth'] = typeof xHuggingfaceAuth === 'string'
                    ? xHuggingfaceAuth
                    : JSON.stringify(xHuggingfaceAuth);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Verifies OTP, returning action token for received action type
         * @summary Verify OTP
         * @param {number} [xUserID] Authenticated User ID — set by auth middleware, do not send manually
         * @param {string} [xAuthError] Auth error message — set by auth middleware, do not send manually
         * @param {boolean} [xHuggingfaceAuth] Huggingface auth flag — set by auth middleware, do not send manually
         * @param {ApiOTPVerifyInput} [apiOTPVerifyInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyOTP: async (xUserID?: number, xAuthError?: string, xHuggingfaceAuth?: boolean, apiOTPVerifyInput?: ApiOTPVerifyInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/otp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xUserID != null) {
                localVarHeaderParameter['X-User-ID'] = typeof xUserID === 'string'
                    ? xUserID
                    : JSON.stringify(xUserID);
            }

            if (xAuthError != null) {
                localVarHeaderParameter['X-Auth-Error'] = String(xAuthError);
            }

            if (xHuggingfaceAuth != null) {
                localVarHeaderParameter['X-Huggingface-Auth'] = typeof xHuggingfaceAuth === 'string'
                    ? xHuggingfaceAuth
                    : JSON.stringify(xHuggingfaceAuth);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiOTPVerifyInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
    return {
        /**
         * Activates account from email token and sets password.
         * @summary Activate account
         * @param {ApiActivateRegisterInput} [apiActivateRegisterInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNewAPIServiceFunc23(apiActivateRegisterInput?: ApiActivateRegisterInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNewAPIServiceFunc23(apiActivateRegisterInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AuthApi.apiNewAPIServiceFunc23']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Requests reset OTP by username/email with IP rate limit.
         * @summary Request password reset
         * @param {string} [xClientIP] Client IP set by API middleware
         * @param {string} [xForwardedFor] 
         * @param {string} [xRealIP] 
         * @param {ApiPasswordResetRequestInput} [apiPasswordResetRequestInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNewAPIServiceFunc24(xClientIP?: string, xForwardedFor?: string, xRealIP?: string, apiPasswordResetRequestInput?: ApiPasswordResetRequestInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNewAPIServiceFunc24(xClientIP, xForwardedFor, xRealIP, apiPasswordResetRequestInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AuthApi.apiNewAPIServiceFunc24']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Sets new password using reset action token.
         * @summary Confirm password reset
         * @param {ApiPasswordResetConfirmInput} [apiPasswordResetConfirmInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNewAPIServiceFunc25(apiPasswordResetConfirmInput?: ApiPasswordResetConfirmInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNewAPIServiceFunc25(apiPasswordResetConfirmInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AuthApi.apiNewAPIServiceFunc25']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Changes password
         * @summary Change password
         * @param {number} xUserID Authenticated User ID — set by auth middleware, do not send manually
         * @param {string} [xAuthError] Auth error message — set by auth middleware, do not send manually
         * @param {boolean} [xHuggingfaceAuth] Huggingface auth flag — set by auth middleware, do not send manually
         * @param {ApiChangePasswordInput} [apiChangePasswordInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changePassword(xUserID: number, xAuthError?: string, xHuggingfaceAuth?: boolean, apiChangePasswordInput?: ApiChangePasswordInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changePassword(xUserID, xAuthError, xHuggingfaceAuth, apiChangePasswordInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AuthApi.changePassword']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Returns basic data about authenticated user
         * @summary Get me
         * @param {number} xUserID Authenticated User ID — set by auth middleware, do not send manually
         * @param {string} [xAuthError] Auth error message — set by auth middleware, do not send manually
         * @param {boolean} [xHuggingfaceAuth] Huggingface auth flag — set by auth middleware, do not send manually
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMe(xUserID: number, xAuthError?: string, xHuggingfaceAuth?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiMeOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMe(xUserID, xAuthError, xHuggingfaceAuth, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AuthApi.getMe']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Sets cookie if auth data is valid. Checks if already logged in and cookie is present.
         * @summary Login
         * @param {string} [jwt] we throw an \&#39;already logged in\&#39; error if cookie is valid and userId is present
         * @param {ApiLoginInput} [apiLoginInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(jwt?: string, apiLoginInput?: ApiLoginInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login(jwt, apiLoginInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AuthApi.login']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Invalidates auth cookie
         * @summary Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logout(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logout(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AuthApi.logout']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Regenerates Bearer API token, use /me to retreive it back afterwards
         * @summary Regenerate Bearer API Token
         * @param {number} xUserID Authenticated User ID — set by auth middleware, do not send manually
         * @param {string} [xAuthError] Auth error message — set by auth middleware, do not send manually
         * @param {boolean} [xHuggingfaceAuth] Huggingface auth flag — set by auth middleware, do not send manually
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async regenerateToken(xUserID: number, xAuthError?: string, xHuggingfaceAuth?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.regenerateToken(xUserID, xAuthError, xHuggingfaceAuth, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AuthApi.regenerateToken']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Creates a new user if auth data is valid. Checks if already logged in and cookie is present.
         * @summary Register
         * @param {string} [jwt] we throw an \&#39;already logged in\&#39; error if cookie is valid and userId is present
         * @param {ApiRegisterInput} [apiRegisterInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async register(jwt?: string, apiRegisterInput?: ApiRegisterInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.register(jwt, apiRegisterInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AuthApi.register']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Requests an OTP
         * @summary Request OTP
         * @param {string} [username] 
         * @param {string} [email] 
         * @param {number} [xUserID] Authenticated User ID — set by auth middleware, do not send manually
         * @param {string} [xAuthError] Auth error message — set by auth middleware, do not send manually
         * @param {boolean} [xHuggingfaceAuth] Huggingface auth flag — set by auth middleware, do not send manually
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestOTP(username?: string, email?: string, xUserID?: number, xAuthError?: string, xHuggingfaceAuth?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestOTP(username, email, xUserID, xAuthError, xHuggingfaceAuth, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AuthApi.requestOTP']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Verifies OTP, returning action token for received action type
         * @summary Verify OTP
         * @param {number} [xUserID] Authenticated User ID — set by auth middleware, do not send manually
         * @param {string} [xAuthError] Auth error message — set by auth middleware, do not send manually
         * @param {boolean} [xHuggingfaceAuth] Huggingface auth flag — set by auth middleware, do not send manually
         * @param {ApiOTPVerifyInput} [apiOTPVerifyInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyOTP(xUserID?: number, xAuthError?: string, xHuggingfaceAuth?: boolean, apiOTPVerifyInput?: ApiOTPVerifyInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiOTPVerifyOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyOTP(xUserID, xAuthError, xHuggingfaceAuth, apiOTPVerifyInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AuthApi.verifyOTP']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthApiFp(configuration)
    return {
        /**
         * Activates account from email token and sets password.
         * @summary Activate account
         * @param {AuthApiApiNewAPIServiceFunc23Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNewAPIServiceFunc23(requestParameters: AuthApiApiNewAPIServiceFunc23Request = {}, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiNewAPIServiceFunc23(requestParameters.apiActivateRegisterInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Requests reset OTP by username/email with IP rate limit.
         * @summary Request password reset
         * @param {AuthApiApiNewAPIServiceFunc24Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNewAPIServiceFunc24(requestParameters: AuthApiApiNewAPIServiceFunc24Request = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiNewAPIServiceFunc24(requestParameters.xClientIP, requestParameters.xForwardedFor, requestParameters.xRealIP, requestParameters.apiPasswordResetRequestInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Sets new password using reset action token.
         * @summary Confirm password reset
         * @param {AuthApiApiNewAPIServiceFunc25Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNewAPIServiceFunc25(requestParameters: AuthApiApiNewAPIServiceFunc25Request = {}, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiNewAPIServiceFunc25(requestParameters.apiPasswordResetConfirmInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Changes password
         * @summary Change password
         * @param {AuthApiChangePasswordRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword(requestParameters: AuthApiChangePasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.changePassword(requestParameters.xUserID, requestParameters.xAuthError, requestParameters.xHuggingfaceAuth, requestParameters.apiChangePasswordInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns basic data about authenticated user
         * @summary Get me
         * @param {AuthApiGetMeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMe(requestParameters: AuthApiGetMeRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiMeOutput> {
            return localVarFp.getMe(requestParameters.xUserID, requestParameters.xAuthError, requestParameters.xHuggingfaceAuth, options).then((request) => request(axios, basePath));
        },
        /**
         * Sets cookie if auth data is valid. Checks if already logged in and cookie is present.
         * @summary Login
         * @param {AuthApiLoginRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(requestParameters: AuthApiLoginRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.login(requestParameters.jwt, requestParameters.apiLoginInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Invalidates auth cookie
         * @summary Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.logout(options).then((request) => request(axios, basePath));
        },
        /**
         * Regenerates Bearer API token, use /me to retreive it back afterwards
         * @summary Regenerate Bearer API Token
         * @param {AuthApiRegenerateTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regenerateToken(requestParameters: AuthApiRegenerateTokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.regenerateToken(requestParameters.xUserID, requestParameters.xAuthError, requestParameters.xHuggingfaceAuth, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new user if auth data is valid. Checks if already logged in and cookie is present.
         * @summary Register
         * @param {AuthApiRegisterRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register(requestParameters: AuthApiRegisterRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.register(requestParameters.jwt, requestParameters.apiRegisterInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Requests an OTP
         * @summary Request OTP
         * @param {AuthApiRequestOTPRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestOTP(requestParameters: AuthApiRequestOTPRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.requestOTP(requestParameters.username, requestParameters.email, requestParameters.xUserID, requestParameters.xAuthError, requestParameters.xHuggingfaceAuth, options).then((request) => request(axios, basePath));
        },
        /**
         * Verifies OTP, returning action token for received action type
         * @summary Verify OTP
         * @param {AuthApiVerifyOTPRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyOTP(requestParameters: AuthApiVerifyOTPRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiOTPVerifyOutput> {
            return localVarFp.verifyOTP(requestParameters.xUserID, requestParameters.xAuthError, requestParameters.xHuggingfaceAuth, requestParameters.apiOTPVerifyInput, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthApi - interface
 * @export
 * @interface AuthApi
 */
export interface AuthApiInterface {
    /**
     * Activates account from email token and sets password.
     * @summary Activate account
     * @param {ApiActivateRegisterInput} [apiActivateRegisterInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    apiNewAPIServiceFunc23(apiActivateRegisterInput?: ApiActivateRegisterInput, options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * Requests reset OTP by username/email with IP rate limit.
     * @summary Request password reset
     * @param {string} [xClientIP] Client IP set by API middleware
     * @param {string} [xForwardedFor] 
     * @param {string} [xRealIP] 
     * @param {ApiPasswordResetRequestInput} [apiPasswordResetRequestInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    apiNewAPIServiceFunc24(xClientIP?: string, xForwardedFor?: string, xRealIP?: string, apiPasswordResetRequestInput?: ApiPasswordResetRequestInput, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Sets new password using reset action token.
     * @summary Confirm password reset
     * @param {ApiPasswordResetConfirmInput} [apiPasswordResetConfirmInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    apiNewAPIServiceFunc25(apiPasswordResetConfirmInput?: ApiPasswordResetConfirmInput, options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * Changes password
     * @summary Change password
     * @param {number} xUserID Authenticated User ID — set by auth middleware, do not send manually
     * @param {string} [xAuthError] Auth error message — set by auth middleware, do not send manually
     * @param {boolean} [xHuggingfaceAuth] Huggingface auth flag — set by auth middleware, do not send manually
     * @param {ApiChangePasswordInput} [apiChangePasswordInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    changePassword(xUserID: number, xAuthError?: string, xHuggingfaceAuth?: boolean, apiChangePasswordInput?: ApiChangePasswordInput, options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * Returns basic data about authenticated user
     * @summary Get me
     * @param {number} xUserID Authenticated User ID — set by auth middleware, do not send manually
     * @param {string} [xAuthError] Auth error message — set by auth middleware, do not send manually
     * @param {boolean} [xHuggingfaceAuth] Huggingface auth flag — set by auth middleware, do not send manually
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    getMe(xUserID: number, xAuthError?: string, xHuggingfaceAuth?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<ApiMeOutput>;

    /**
     * Sets cookie if auth data is valid. Checks if already logged in and cookie is present.
     * @summary Login
     * @param {string} [jwt] we throw an \&#39;already logged in\&#39; error if cookie is valid and userId is present
     * @param {ApiLoginInput} [apiLoginInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    login(jwt?: string, apiLoginInput?: ApiLoginInput, options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * Invalidates auth cookie
     * @summary Logout
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    logout(options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * Regenerates Bearer API token, use /me to retreive it back afterwards
     * @summary Regenerate Bearer API Token
     * @param {number} xUserID Authenticated User ID — set by auth middleware, do not send manually
     * @param {string} [xAuthError] Auth error message — set by auth middleware, do not send manually
     * @param {boolean} [xHuggingfaceAuth] Huggingface auth flag — set by auth middleware, do not send manually
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    regenerateToken(xUserID: number, xAuthError?: string, xHuggingfaceAuth?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * Creates a new user if auth data is valid. Checks if already logged in and cookie is present.
     * @summary Register
     * @param {string} [jwt] we throw an \&#39;already logged in\&#39; error if cookie is valid and userId is present
     * @param {ApiRegisterInput} [apiRegisterInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    register(jwt?: string, apiRegisterInput?: ApiRegisterInput, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Requests an OTP
     * @summary Request OTP
     * @param {string} [username] 
     * @param {string} [email] 
     * @param {number} [xUserID] Authenticated User ID — set by auth middleware, do not send manually
     * @param {string} [xAuthError] Auth error message — set by auth middleware, do not send manually
     * @param {boolean} [xHuggingfaceAuth] Huggingface auth flag — set by auth middleware, do not send manually
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    requestOTP(username?: string, email?: string, xUserID?: number, xAuthError?: string, xHuggingfaceAuth?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Verifies OTP, returning action token for received action type
     * @summary Verify OTP
     * @param {number} [xUserID] Authenticated User ID — set by auth middleware, do not send manually
     * @param {string} [xAuthError] Auth error message — set by auth middleware, do not send manually
     * @param {boolean} [xHuggingfaceAuth] Huggingface auth flag — set by auth middleware, do not send manually
     * @param {ApiOTPVerifyInput} [apiOTPVerifyInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    verifyOTP(xUserID?: number, xAuthError?: string, xHuggingfaceAuth?: boolean, apiOTPVerifyInput?: ApiOTPVerifyInput, options?: RawAxiosRequestConfig): AxiosPromise<ApiOTPVerifyOutput>;

}

/**
 * Request parameters for apiNewAPIServiceFunc23 operation in AuthApi.
 * @export
 * @interface AuthApiApiNewAPIServiceFunc23Request
 */
export interface AuthApiApiNewAPIServiceFunc23Request {
    /**
     * 
     * @type {ApiActivateRegisterInput}
     * @memberof AuthApiApiNewAPIServiceFunc23
     */
    readonly apiActivateRegisterInput?: ApiActivateRegisterInput
}

/**
 * Request parameters for apiNewAPIServiceFunc24 operation in AuthApi.
 * @export
 * @interface AuthApiApiNewAPIServiceFunc24Request
 */
export interface AuthApiApiNewAPIServiceFunc24Request {
    /**
     * Client IP set by API middleware
     * @type {string}
     * @memberof AuthApiApiNewAPIServiceFunc24
     */
    readonly xClientIP?: string

    /**
     * 
     * @type {string}
     * @memberof AuthApiApiNewAPIServiceFunc24
     */
    readonly xForwardedFor?: string

    /**
     * 
     * @type {string}
     * @memberof AuthApiApiNewAPIServiceFunc24
     */
    readonly xRealIP?: string

    /**
     * 
     * @type {ApiPasswordResetRequestInput}
     * @memberof AuthApiApiNewAPIServiceFunc24
     */
    readonly apiPasswordResetRequestInput?: ApiPasswordResetRequestInput
}

/**
 * Request parameters for apiNewAPIServiceFunc25 operation in AuthApi.
 * @export
 * @interface AuthApiApiNewAPIServiceFunc25Request
 */
export interface AuthApiApiNewAPIServiceFunc25Request {
    /**
     * 
     * @type {ApiPasswordResetConfirmInput}
     * @memberof AuthApiApiNewAPIServiceFunc25
     */
    readonly apiPasswordResetConfirmInput?: ApiPasswordResetConfirmInput
}

/**
 * Request parameters for changePassword operation in AuthApi.
 * @export
 * @interface AuthApiChangePasswordRequest
 */
export interface AuthApiChangePasswordRequest {
    /**
     * Authenticated User ID — set by auth middleware, do not send manually
     * @type {number}
     * @memberof AuthApiChangePassword
     */
    readonly xUserID: number

    /**
     * Auth error message — set by auth middleware, do not send manually
     * @type {string}
     * @memberof AuthApiChangePassword
     */
    readonly xAuthError?: string

    /**
     * Huggingface auth flag — set by auth middleware, do not send manually
     * @type {boolean}
     * @memberof AuthApiChangePassword
     */
    readonly xHuggingfaceAuth?: boolean

    /**
     * 
     * @type {ApiChangePasswordInput}
     * @memberof AuthApiChangePassword
     */
    readonly apiChangePasswordInput?: ApiChangePasswordInput
}

/**
 * Request parameters for getMe operation in AuthApi.
 * @export
 * @interface AuthApiGetMeRequest
 */
export interface AuthApiGetMeRequest {
    /**
     * Authenticated User ID — set by auth middleware, do not send manually
     * @type {number}
     * @memberof AuthApiGetMe
     */
    readonly xUserID: number

    /**
     * Auth error message — set by auth middleware, do not send manually
     * @type {string}
     * @memberof AuthApiGetMe
     */
    readonly xAuthError?: string

    /**
     * Huggingface auth flag — set by auth middleware, do not send manually
     * @type {boolean}
     * @memberof AuthApiGetMe
     */
    readonly xHuggingfaceAuth?: boolean
}

/**
 * Request parameters for login operation in AuthApi.
 * @export
 * @interface AuthApiLoginRequest
 */
export interface AuthApiLoginRequest {
    /**
     * we throw an \&#39;already logged in\&#39; error if cookie is valid and userId is present
     * @type {string}
     * @memberof AuthApiLogin
     */
    readonly jwt?: string

    /**
     * 
     * @type {ApiLoginInput}
     * @memberof AuthApiLogin
     */
    readonly apiLoginInput?: ApiLoginInput
}

/**
 * Request parameters for regenerateToken operation in AuthApi.
 * @export
 * @interface AuthApiRegenerateTokenRequest
 */
export interface AuthApiRegenerateTokenRequest {
    /**
     * Authenticated User ID — set by auth middleware, do not send manually
     * @type {number}
     * @memberof AuthApiRegenerateToken
     */
    readonly xUserID: number

    /**
     * Auth error message — set by auth middleware, do not send manually
     * @type {string}
     * @memberof AuthApiRegenerateToken
     */
    readonly xAuthError?: string

    /**
     * Huggingface auth flag — set by auth middleware, do not send manually
     * @type {boolean}
     * @memberof AuthApiRegenerateToken
     */
    readonly xHuggingfaceAuth?: boolean
}

/**
 * Request parameters for register operation in AuthApi.
 * @export
 * @interface AuthApiRegisterRequest
 */
export interface AuthApiRegisterRequest {
    /**
     * we throw an \&#39;already logged in\&#39; error if cookie is valid and userId is present
     * @type {string}
     * @memberof AuthApiRegister
     */
    readonly jwt?: string

    /**
     * 
     * @type {ApiRegisterInput}
     * @memberof AuthApiRegister
     */
    readonly apiRegisterInput?: ApiRegisterInput
}

/**
 * Request parameters for requestOTP operation in AuthApi.
 * @export
 * @interface AuthApiRequestOTPRequest
 */
export interface AuthApiRequestOTPRequest {
    /**
     * 
     * @type {string}
     * @memberof AuthApiRequestOTP
     */
    readonly username?: string

    /**
     * 
     * @type {string}
     * @memberof AuthApiRequestOTP
     */
    readonly email?: string

    /**
     * Authenticated User ID — set by auth middleware, do not send manually
     * @type {number}
     * @memberof AuthApiRequestOTP
     */
    readonly xUserID?: number

    /**
     * Auth error message — set by auth middleware, do not send manually
     * @type {string}
     * @memberof AuthApiRequestOTP
     */
    readonly xAuthError?: string

    /**
     * Huggingface auth flag — set by auth middleware, do not send manually
     * @type {boolean}
     * @memberof AuthApiRequestOTP
     */
    readonly xHuggingfaceAuth?: boolean
}

/**
 * Request parameters for verifyOTP operation in AuthApi.
 * @export
 * @interface AuthApiVerifyOTPRequest
 */
export interface AuthApiVerifyOTPRequest {
    /**
     * Authenticated User ID — set by auth middleware, do not send manually
     * @type {number}
     * @memberof AuthApiVerifyOTP
     */
    readonly xUserID?: number

    /**
     * Auth error message — set by auth middleware, do not send manually
     * @type {string}
     * @memberof AuthApiVerifyOTP
     */
    readonly xAuthError?: string

    /**
     * Huggingface auth flag — set by auth middleware, do not send manually
     * @type {boolean}
     * @memberof AuthApiVerifyOTP
     */
    readonly xHuggingfaceAuth?: boolean

    /**
     * 
     * @type {ApiOTPVerifyInput}
     * @memberof AuthApiVerifyOTP
     */
    readonly apiOTPVerifyInput?: ApiOTPVerifyInput
}

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI implements AuthApiInterface {
    /**
     * Activates account from email token and sets password.
     * @summary Activate account
     * @param {AuthApiApiNewAPIServiceFunc23Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public apiNewAPIServiceFunc23(requestParameters: AuthApiApiNewAPIServiceFunc23Request = {}, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiNewAPIServiceFunc23(requestParameters.apiActivateRegisterInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Requests reset OTP by username/email with IP rate limit.
     * @summary Request password reset
     * @param {AuthApiApiNewAPIServiceFunc24Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public apiNewAPIServiceFunc24(requestParameters: AuthApiApiNewAPIServiceFunc24Request = {}, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiNewAPIServiceFunc24(requestParameters.xClientIP, requestParameters.xForwardedFor, requestParameters.xRealIP, requestParameters.apiPasswordResetRequestInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sets new password using reset action token.
     * @summary Confirm password reset
     * @param {AuthApiApiNewAPIServiceFunc25Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public apiNewAPIServiceFunc25(requestParameters: AuthApiApiNewAPIServiceFunc25Request = {}, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiNewAPIServiceFunc25(requestParameters.apiPasswordResetConfirmInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Changes password
     * @summary Change password
     * @param {AuthApiChangePasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public changePassword(requestParameters: AuthApiChangePasswordRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).changePassword(requestParameters.xUserID, requestParameters.xAuthError, requestParameters.xHuggingfaceAuth, requestParameters.apiChangePasswordInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns basic data about authenticated user
     * @summary Get me
     * @param {AuthApiGetMeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public getMe(requestParameters: AuthApiGetMeRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).getMe(requestParameters.xUserID, requestParameters.xAuthError, requestParameters.xHuggingfaceAuth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sets cookie if auth data is valid. Checks if already logged in and cookie is present.
     * @summary Login
     * @param {AuthApiLoginRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public login(requestParameters: AuthApiLoginRequest = {}, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).login(requestParameters.jwt, requestParameters.apiLoginInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Invalidates auth cookie
     * @summary Logout
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public logout(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).logout(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Regenerates Bearer API token, use /me to retreive it back afterwards
     * @summary Regenerate Bearer API Token
     * @param {AuthApiRegenerateTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public regenerateToken(requestParameters: AuthApiRegenerateTokenRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).regenerateToken(requestParameters.xUserID, requestParameters.xAuthError, requestParameters.xHuggingfaceAuth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new user if auth data is valid. Checks if already logged in and cookie is present.
     * @summary Register
     * @param {AuthApiRegisterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public register(requestParameters: AuthApiRegisterRequest = {}, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).register(requestParameters.jwt, requestParameters.apiRegisterInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Requests an OTP
     * @summary Request OTP
     * @param {AuthApiRequestOTPRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public requestOTP(requestParameters: AuthApiRequestOTPRequest = {}, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).requestOTP(requestParameters.username, requestParameters.email, requestParameters.xUserID, requestParameters.xAuthError, requestParameters.xHuggingfaceAuth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Verifies OTP, returning action token for received action type
     * @summary Verify OTP
     * @param {AuthApiVerifyOTPRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public verifyOTP(requestParameters: AuthApiVerifyOTPRequest = {}, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).verifyOTP(requestParameters.xUserID, requestParameters.xAuthError, requestParameters.xHuggingfaceAuth, requestParameters.apiOTPVerifyInput, options).then((request) => request(this.axios, this.basePath));
    }
}

